<div class="workspace-wrapper">
    <app-area-header
        [smallHeadlineRaw]="'workspace.components.workspaceComponent.smallHeader' | translate: { userName: userName }"
        [largeHeadline]="'workspace.components.workspaceComponent.largeHeader' | translate"
        [profilePicture]="'assets/svg/sidebar-nav/workspace-icon.svg'"
        [round]="false"
    ></app-area-header>
    <div class="main-area-wrapper">
        <div class="user-notification" *ngIf="displayNotification">
            <i class="bi bi-info-circle"></i>
            <div class="notification" role="status" aria-live="polite">{{ notification }}</div>
        </div>
        <div class="description-wrapper">
            <p class="greeting">
                {{ 'workspace.components.workspaceComponent.descriptions.greeting' | translate }}
            </p>
            <p class="tryb-intro">
                {{ 'workspace.components.workspaceComponent.descriptions.trybIntro' | translate }}
            </p>
            <p class="general-description">
                <span class="workspace-intro">
                    {{ 'workspace.components.workspaceComponent.descriptions.workspaceIntro' | translate }}
                </span>
                <span class="navigation-explanation">
                    {{ 'workspace.components.workspaceComponent.descriptions.navigationExplanation' | translate }}
                </span>
            </p>
        </div>
        <div class="boxes-wrapper">
            <div [ngClass]="['box', `${box.key}-box`]" [id]="box.key + '-box'"
                 *ngFor="let box of boxes">
                <div class="box-texts-wrapper">
                    <p class="box-header">{{ `workspace.components.workspaceComponent.boxes.${box.key}.header` | translate }}</p>
                    <p class="box-description">
                        <span
                            class="intro">{{ `workspace.components.workspaceComponent.boxes.${box.key}.description.intro` | translate }}
                        </span>
                        <span
                            class="details">{{ `workspace.components.workspaceComponent.boxes.${box.key}.description.details` | translate }}
                        </span>
                    </p>
                </div>

                <div class="button-wrapper button-wrapper-tryb-button"
                     [id]="box.key + '-button-wrapper'">
                    <button class="button-tryb-button basic-tryb-button"
                            (click)="onBoxButtonClick(box.key)">
                        {{ `workspace.components.workspaceComponent.boxes.${box.key}.button` | translate }}
                    </button>
                </div>

                <img class="box-background-icon" [ngClass]="box.key + '-icon'" [src]="box.iconSrc"
                     [alt]="box.key + '-icon'" aria-hidden="true" />
            </div>
        </div>
    </div>
</div>
